import angular from "angular";

angular
    .module('app')
    .component('userPermissions', {
        template: require('./user-permissions.html'),
        controller: ['$http', 'ErrorResponseParser', 'Notifier', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller($http, ErrorResponseParser, Notifier) {

    let $ctrl = this;

    $ctrl.$onInit = function () {
        $ctrl.permissions = $ctrl.resolve.permissions;
        $ctrl.user = $ctrl.resolve.user;
        $ctrl.permissions.forEach(function (permission) {
            permission.isSelected = !!$ctrl.user.permissions.find(p => p.id == permission.id);
        });

    };

    $ctrl.togglePermission = function (permission) {
        permission.isSelected = !permission.isSelected;
    };

    $ctrl.save = function () {

        $ctrl.loading = true;

        let selectedPermissions = $ctrl.permissions.filter(p => p.isSelected);

        let permissionsIds = [];
        selectedPermissions.forEach(function (p) {
            permissionsIds.push(p.id);
        });

        $http
            .post(`/admin/users/${$ctrl.user.id}/sync-permissions`, {permissions_ids: permissionsIds})
            .then(
                function (response) {
                    $ctrl.user.permissions = selectedPermissions;
                    $ctrl.close();

                    Notifier.success('Данные успешно обновлены', 2);
                },
                function (error) {
                    $ctrl.loading = false;
                    ErrorResponseParser.parse(error);

                    Notifier.error('Произошла ошибка', 2)
                }
            );
    };

}
